import React from 'react';
import { TablePagination } from '@mui/material';

type TablePaginationProps = {
  count: number;
  page: number;
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (newRowsPerPage: number) => void;
  rowsPerPage: number;
  rowsPerPageOptions?: number[];
};

export const Pagination = ({
                             count,
                             page,
                             onPageChange,
                             onRowsPerPageChange,
                             rowsPerPage = 10,
                             rowsPerPageOptions = [10, 20, 30],
                           }: TablePaginationProps) => {
  console.log(`page: ${page}`)
  console.log(`count: ${count}`)
  const handleChangePage = (_event: unknown, newPage: number) => {
    onPageChange(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    onRowsPerPageChange(parseInt(event.target.value, 10));
  };

  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions}
    />
  );
};
